module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-pride-large-24c63ea764469347c854ebc073494aaf.jpg";